import { render, staticRenderFns } from "./ListFeaturesPanel.vue?vue&type=template&id=1b054465&scoped=true&"
import script from "./ListFeaturesPanel.vue?vue&type=script&lang=js&"
export * from "./ListFeaturesPanel.vue?vue&type=script&lang=js&"
import style0 from "./ListFeaturesPanel.vue?vue&type=style&index=0&id=1b054465&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b054465",
  null
  
)

export default component.exports